import { c as _c } from "react/compiler-runtime";
import { Dialog, DialogContent, DialogTrigger } from "@repo/ui/dialog";
import type { DialogCardProps } from "./dialog-card.types";

/**
 * Shared wrapper used by cards that toggle between a static state (no
 * panel content) and an interactive state (opens a `Dialog` panel on
 * click). Centralises the dialog plumbing so individual cards only
 * decide what their trigger element and panel content look like.
 *
 * Both branches share:
 *   - `transition="fade"` on the dialog content
 *   - The default `DialogContent` close button (top-right X icon)
 *
 * Used by `PersonCard` and `CommercialTenantCard`.
 */
export function DialogCard(t0) {
  const $ = _c(10);
  const {
    enabled,
    trigger,
    panel,
    contentClassName
  } = t0;
  if (!enabled) {
    let t1;
    if ($[0] !== trigger) {
      t1 = <>{trigger}</>;
      $[0] = trigger;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== trigger) {
    t1 = <DialogTrigger asChild={true}>{trigger}</DialogTrigger>;
    $[2] = trigger;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== contentClassName || $[5] !== panel) {
    t2 = <DialogContent transition="fade" className={contentClassName}>{panel}</DialogContent>;
    $[4] = contentClassName;
    $[5] = panel;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <Dialog>{t1}{t2}</Dialog>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}